export { MainPage } from './main-page';
export { mainPageI18n } from './main-page.i18n'